import { render, staticRenderFns } from "./addDataManage.vue?vue&type=template&id=dac1ae2a&scoped=true"
import script from "./addDataManage.vue?vue&type=script&lang=js"
export * from "./addDataManage.vue?vue&type=script&lang=js"
import style0 from "./addDataManage.vue?vue&type=style&index=0&id=dac1ae2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac1ae2a",
  null
  
)

export default component.exports